import React, { CSSProperties, ReactNode, useState } from "react";
import { Label } from "../Label/Label";
import { Popup } from "../Popup/Popup";
import styles from "./PopupContainer.module.css";

export interface PopupContainerStylingProps {
  // Styling options
  className?: string;
  centered?: boolean;
  verticalCenter?: boolean;
  horizontalCenter?: boolean;

  topMargin?: string;
  disablePadding?: boolean;
  backgroundColor?: string;
  title?: string;
  closable?: boolean;
  closeWithBackshadow?: boolean;
  width?: string;
  maxWidth?: string;
  minWidth?: string;
  maxHeight?: string;

  style?: CSSProperties;
}

export interface PopupContainerProps extends PopupContainerStylingProps {
  id: string;
  children: ReactNode;
}

export const PopupContainer = (props: PopupContainerProps) => {
  const [mouseDownOnBackdrop, setMouseDownOnBackdrop] = useState(false);

  let styling: string = styles.base + " ";

  //Add styling-options
  if (props.className) styling += props.className + " ";
  if (props.centered) styling += styles.verticalCenter + " " + styles.horizontalCenter + " ";
  if (props.verticalCenter) styling += styles.verticalCenter + " ";
  if (props.horizontalCenter) styling += styles.horizontalCenter + " ";
  if (!props.disablePadding) styling += styles.standardPadding;

  function onBackshadowClick(e: React.MouseEvent<HTMLDivElement, MouseEvent>) {
    if (!mouseDownOnBackdrop) {
      return;
    }
    if (props.closeWithBackshadow !== undefined && props.closeWithBackshadow === false) {
      return;
    }
    if (e.target !== e.currentTarget) {
      return;
    }
    Popup.remove(props.id);
    setMouseDownOnBackdrop(false);
  }

  const onMouseDown = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (e.target !== e.currentTarget) {
      return;
    }
    setMouseDownOnBackdrop(true);
  };

  const customStyle: CSSProperties = {
    backgroundColor: props.backgroundColor ?? "var(--bg-2-color)",
    width: props.width,
    maxWidth: props.maxWidth,
    minWidth: props.minWidth,
    marginTop: props.topMargin,
    maxHeight: props.maxHeight,
    overflowY: "auto",

    ...props.style,
  };

  return (
    <div onClick={onBackshadowClick} onMouseDown={onMouseDown} className={styles.container}>
      <div id={props.id} className={styling} style={customStyle} data-cy="popup-container">
        {(props.title || props.closable) && <TitleBar id={props.id} title={props.title} closable={props.closable} />}
        <div className={styles.content} data-cy="popup-content" onMouseEnter={() => setMouseDownOnBackdrop(false)}>
          {props.children}
        </div>
      </div>
    </div>
  );
};

type TitleBarProps = {
  id: string;
  title?: string;
  closable?: boolean;
};

const TitleBar = (props: TitleBarProps) => (
  <div className={styles.titleBar}>
    <Label className={styles.title} type={"subtitle-2"} text={props.title ?? " "} data-cy="popup-title" />
    {props.closable && (
      <i onClick={() => Popup.remove(props.id)} className={`material-icons ${styles.closeButton}`}>
        clear
      </i>
    )}
  </div>
);
